import * as React from 'react';
import '../../styles/hcldx.scss'

const DeployedToHcldx = () => (<React.Fragment></React.Fragment>);

export default DeployedToHcldx;